import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthService } from '../services/auth.service';

@Component({
  selector: 'app-subscription',
  templateUrl: './subscription.component.html',
  styleUrls: ['./subscription.component.css']
})
export class SubscriptionComponent implements OnInit {
  message = 'Please wait...';
  hasError = false;

  constructor(
    private activatedRoute: ActivatedRoute,
    private authService: AuthService,
    private router: Router
  ) {
    this.activatedRoute.queryParams.subscribe(params => {
      const code = params['code'];
      // console.log(code);
      if (code) {
        authService.createStripeAccount(code).subscribe(
          () => {
            this.router.navigateByUrl('/manage');
          },
          error => {
            this.hasError = true;
            this.message = '';

            console.log('error sub comp');
          }
        );
      }
    });
  }

  ngOnInit() {}
}
